module.exports = __webpack_public_path__ + "resources/img/zoom_pseudo_fullscreen.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom_pseudo_fullscreen.png
// module id = 1374
// module chunks = 0